var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustpilotStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_639_19753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4202 12.5031L15.0627 17.5596L9.503 13.5186L13.4202 12.5031ZM18.5 6.98313H11.6263L9.50375 0.442383L7.37375 6.98463L0.5 6.97563L6.0665 11.0234L3.9365 17.5589L9.503 13.5186L12.9403 11.0234L18.5 6.98313Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_639_19753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilotStar);
export default __webpack_public_path__ + "static/media/trustpilot-star.348bd88d61c08b057b8301c8f323f26e.svg";
export { ForwardRef as ReactComponent };